<div
    class="modal fade show" 
    [ngClass]="{'expanded': !isExpanded}"
    id="cycle-count-upload-detail-modal" 
    tabindex="-1" 
    aria-labelledby="cycle-count-upload-detail-modalLabel" 
    aria-hidden="true"
    [ngStyle]="{'display': 'block'}"
>
    <div class="modal-dialog modal-xl">
        <app-loader *ngIf="showLoader"></app-loader>
        <div class="modal-content">
            <div class="modal-header">
                <div class="d-flex w-100">
                    <div class="me-2 id flex-fill">
                        <h4 class="modal-title mb-0 item-id">Cycle Count Upload</h4>
                    </div>
            
                    <div class="btns-header">
                        <button 
                            class="header-icon close p-0 m-0" 
                            (click)="close()" 
                            aria-label="Close"
                        >
                            <i 
                                class="fas fa-times" 
                                title="Close Popup"
                            ></i>
                        </button>
                        <button 
                            class="close header-icon expand-modal p-0 m-0"
                            (click)="expand()"
                        >
                            <i 
                                class="fas ms-2 me-2" 
                                [ngClass]="{'fa-expand-alt': !isExpanded, 'fa-compress-alt': isExpanded}" 
                                [title]="isExpanded ? 'Exit Full Screen' : 'Enter Full Screen'"
                            ></i>
                        </button>
                    </div>
                </div>
            </div>
            <div class="modal-body pt-0">
                <div class="w-100" style="margin-top: 20px;">
                    <ejs-grid
                        #cycleCountUploadDetailGrid
                        id="{{gridName}}"
                        [selectionSettings]='selectionOptions'
                        [dataSource]="uploadDetailData"
                        [query]="query"
                        [height]="gridHeight"
                        [pageSettings]="pageSettings"
                        [gridLines]="false"
                        [allowPaging]="true"
                        [enablePersistence]="false"
                        [allowFiltering]="true"
                        [allowSorting]="true"
                        [allowResizing]="true"
                        [allowReordering]="true"
                        [showColumnChooser]="true"
                        [allowExcelExport]="true"
                        [filterSettings]="{ type: 'Menu' }"
                        [editSettings]="{ allowEditing: false, allowAdding: false, allowDeleting: false , newRowPosition: 'Top' }"
                        [aggregates]="aggreagtes"
                        [toolbar]="$safeNavigationMigration(grid?.toolbar)"
                        (created)="onGridCreated()"
                        (excelQueryCellInfo)="excelQueryCellInfo($event)"
                        (queryCellInfo)="queryCellInfo($event)"
                        (toolbarClick)="onToolbarClick($event, cycleCountUploadDetailGrid)">
                        <e-columns>
                            <e-column
                                *ngFor="let column of mainGrid?.columns;"
                                [field]="column.field"
                                [headerText]="column.headerText"
                                [clipMode]="'EllipsisWithTooltip'"
                                [type]="column.type"
                                [width]="column.width"
                                [isPrimaryKey]="column.isPrimaryKey || false"
                                [validationRules]="column?.validationRules || null"
                                [filter]="column.filter ? column.filter : { type: 'Menu' }"
                                [format]="column.format ? column.format : null"
                                [textAlign]="column.textAlign"
                                [editType]="column.editType"
                                [showInColumnChooser]="column.showInColumnChooser ?? true"
                                [visible]="column.visible"
                                [commands]="column?.commands ? column.commands : null"
                                [allowEditing]="column.allowEditing ? column.allowEditing : true"
                                [allowReordering]="column.allowReordering ?? true"
                                [edit]="column.edit"
                                [freeze]="column.freeze ? column.freeze: null"
                                [allowFiltering]="column.allowFiltering !== undefined ? column.allowFiltering : true">
                
                                <ng-template *ngIf="column.field === 'itemCode'" #template let-data>
                                    <a href="javascript:" (click)="showMasterItemCodePopup(data)">{{data.itemCode}}</a>
                                </ng-template>
                                <ng-template *ngIf="column.field === 'itemDescription'" #template let-data>
                                    <a href="javascript:" (click)="showMasterItemCodePopup(data)">{{data.itemDescription}}</a>
                                </ng-template>
                                <!-- <ng-template *ngIf="column.field === 'count'" #template let-data>
                                    <span>
                                        {{+data.itemCode + +'2'}}
                                    </span>
                                </ng-template>
                 -->
                            </e-column>
                        </e-columns>
                      </ejs-grid>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-sm btn-info close-modal" (click)="browseFile.emit()">Browse</button>
                <button type="button" class="btn btn-sm btn-success me-1" (click)="fileUpload()">Upload</button>
            </div>
        </div>
    </div>
</div>

<ng-template #columnChooser>
    <app-column-chooser
        [grid]="grid"
        (onClose)="showColumnChooser = false"
    ></app-column-chooser>
</ng-template>